import { cva } from 'class-variance-authority';

/**
 * Styles for LoginHeader component
 * Matches Figma design specifications for login page
 * Uses CSS-based responsive styling instead of JavaScript conditionals
 */
export const loginHeaderStyles = cva(
  [
    'flex',
    'flex-col',
    'gap-3', // 12px gap between title and description per Figma
    'items-start',
    'mb-8', // 32px margin-bottom on mobile (space between header and card)
    'w-full',
    // Tablet: match card width (396px) and center - same as personal info screen
    'md:max-w-[396px]',
    'md:mx-auto',
    'md:mb-0', // No margin-bottom on tablet/desktop - gap handled by parent
    // Desktop: match card width (476px) and center - same as personal info screen
    'lg:max-w-[476px]',
  ],
  {
    variants: {},
    defaultVariants: {},
  }
);
